import * as consts from '@core_n/common/consts';

export const MSG_TYPE_SENSOR_BIAS = 1000;

export const SNS_TRACK_DISPLAY_ELEMENT_IP = consts.SNS_TRACK_DISPLAY_ELEMENT_LAST + 1;
export const SNS_TRACK_DISPLAY_ELEMENT_LAST = SNS_TRACK_DISPLAY_ELEMENT_IP;

export const POINT_DISPLAY_ELEMENT_COVERAGE = consts.POINT_DISPLAY_ELEMENT_LAST + 1;
export const POINT_DISPLAY_ELEMENT_LAST = POINT_DISPLAY_ELEMENT_COVERAGE;

// Project server actions
export const USER_ACTION_MERGE_TRACKS = 0;
export const USER_ACTION_SET_DOUBLE_FLAG = 1;
export const USER_ACTION_RESET_BIASES = 2;
export const USER_ACTION_UNREGISTER = 3;

//new ones...
export const USER_ACTION_CREATE_TRACK = 1;
export const USER_ACTION_DROP_TRACK = 2;
export const USER_ACTION_UPDATE_TRACK = 3;
export const USER_ACTION_MERGE_TRACK = 4;
export const USER_ACTION_SET_CLASSIFICATION = 5;
export const USER_ACTION_SET_HOSTILITY = 6;
export const USER_ACTION_NAINAT = 7;
export const USER_ACTION_THREAT_BASE = 8;
export const USER_ACTION_SET_RADAR_PARAMETERS = 9;
export const USER_ACTION_ASSOCIATE_TRACKS_FOR_REGISTRATION = 10;
export const USER_ACTION_FORBID_DELETION = 11;
export const USER_ACTION_GET_SENSORS = 12;
export const USER_ACTION_GET_TRACKS = 13;
export const USER_ACTION_GET_HEIGHT = 14;
export const USER_ACTION_GET_CLSARM = 15;
export const USER_ACTION_EXTIP = 16;
export const USER_ACTION_SET_SENSOR = 17;
export const USER_ACTION_CLIENT_INIT = 18;
export const USER_ACTION_FORCE_SEND_TO_SMART = 19;
export const USER_ACTION_START_PLAYBACK = 22;
export const USER_ACTION_PLAYBACK_SPEED = 23;


// Project local actions
export const USER_ACTION_SHOW_ARO = 1000;
export const USER_ACTION_SENSOR_BIAS = 10000;

export class ProjConstants extends consts.Constants {

  msgTypeTitle(msgType: number): string {
    switch (msgType) {
      case MSG_TYPE_SENSOR_BIAS: return 'Sensor Bias';
      default: return super.msgTypeTitle(msgType);
    }
  }

  sysTrackDisplayElementCount(): number {
    return consts.SYS_TRACK_DISPLAY_ELEMENT_LAST;
  }

  sysTrackDisplayElementTitle(element: number): string {
    return super.sysTrackDisplayElementTitle(element);
  }

  snsTrackDisplayElementCount(): number {
    return SNS_TRACK_DISPLAY_ELEMENT_LAST + 1;
  }

  snsTrackDisplayElementTitle(element: number): string {
    switch (element) {
      case SNS_TRACK_DISPLAY_ELEMENT_IP: return 'IP';
      default: return super.snsTrackDisplayElementTitle(element);
    }
  }

  pointDisplayElementCount(): number {
    return POINT_DISPLAY_ELEMENT_LAST;
  }

  pointDisplayElementTitle(element: number): string {
    switch (element) {
      // case POINT_DISPLAY_ELEMENT_COVERAGE: return 'Coverage';
      default: return super.pointDisplayElementTitle(element);
    }
  }

  // userActionTitle(userAction: number): string {
  //   switch (userAction) {
  //     case USER_ACTION_MERGE_TRACKS: return 'Merge Tracks...';
  //     case USER_ACTION_SET_DOUBLE_FLAG: return 'Set Double...';
  //     case USER_ACTION_RESET_BIASES: return 'Reset Biases';
  //     case USER_ACTION_UNREGISTER: return 'Unregister';
  //     case USER_ACTION_SENSOR_BIAS: return 'Sensor Bias...';
  //     default: return super.userActionTitle(userAction);
  //   }
  // }

  userActionTitle(userAction: number): string {
    switch (userAction) {
      case USER_ACTION_CREATE_TRACK: return  this.translations['CREATE_CAMERA']; //'Create Track';
      case USER_ACTION_DROP_TRACK: return this.translations['DROP_TRACK'];
      case USER_ACTION_UPDATE_TRACK: return this.translations['UPDATE_TRACK']; //'Update Track';
      case USER_ACTION_MERGE_TRACK: return this.translations['MERGE_TRACK']; // 'Merge Track';
      case USER_ACTION_SET_CLASSIFICATION: return this.translations['SET_IDENTITY']; // 'Set Identity';
      case USER_ACTION_SET_HOSTILITY: return this.translations['SET_HOSTILITY']; //'Set Hostility';
      case USER_ACTION_NAINAT: return this.translations['Add Nai/Nat']; // 'Set/Delete Identity';
      case USER_ACTION_THREAT_BASE: return this.translations['SET_DELETE_THREAT_BASE'];  //'Set/Delete Threat Base';
      case USER_ACTION_SET_RADAR_PARAMETERS: return this.translations['SET_RADAR_PARAMETERS']; //'Set Radar Parameters';
      case USER_ACTION_ASSOCIATE_TRACKS_FOR_REGISTRATION: return this.translations['ASSOCIATE_TRACKS']; //'Associate Tracks for Registration';
      case USER_ACTION_FORBID_DELETION: return this.translations['FORBID_DELETION']; // 'Forbid Deletion';
      case USER_ACTION_GET_HEIGHT: return this.translations['GET_HEIGHT']; //'Get Height';
      default: return super.userActionTitle(userAction);
    }
  }
}
